import React from "react";
import {BarekamIcon, IconVariants} from "../../components/icon/barekam-icon";
import BarekamText from "../../components/text";
import BarekamButton, {SimpleButtons} from "../../components/button";
import {Message, MessageSections} from "../../components/message/message";
import {
    FooterCopyrightContainer,
    FooterInfoBlock,
    FooterInfoBlockItem,
    FooterInfoContainer,
    FooterTermsContainer,
    MobileFooterContainer
} from "../styled";

export const TabletFooter = () => {
    function onTermsClick() {
        window.open('https://barekam.am/Terms-EN.pdf', '_blank', 'rel=noopener noreferrer')
    }

    return (
        <MobileFooterContainer>
            <FooterInfoContainer>
                <FooterInfoBlock>
                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.location} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_address'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>

                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.phone} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_phone'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>
                </FooterInfoBlock>

                <FooterInfoBlock>
                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.email} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_email'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>

                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.footerGlobe} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_website'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>
                </FooterInfoBlock>
            </FooterInfoContainer>

            <FooterTermsContainer>
                <BarekamButton type={SimpleButtons.TERMS_AND_CONDITIONS} onClick={() => onTermsClick()}>
                    <BarekamText variant={'s'} style={{textDecoration: 'underline'}} opaque>
                        <Message messageKey={'terms_and_conditions'} sectionId={MessageSections.MAIN}/>
                    </BarekamText>
                </BarekamButton>
            </FooterTermsContainer>


            <FooterCopyrightContainer>
                <BarekamText variant={'s'} color={'#A9A9C2'} width={'unset'} fontWeight={400}>
                    <Message messageKey={'footer_copyright'} sectionId={MessageSections.MAIN}/>
                </BarekamText>
            </FooterCopyrightContainer>
        </MobileFooterContainer>
    )
}